export default __webpack_public_path__ + "static/media/03.2dbf6534.png";